import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { FfEndPoints } from "../../../ff-endpoints";

@Component({
    selector: 'app-portfolio-creation-failure',
    templateUrl: './portfolio-creation-failure.component.html',
    styleUrls: ['./portfolio-creation-failure.component.scss']
})
export class PortfolioCreationFailureComponent {
    private router: Router;
    constructor(
        router: Router,
    ) {
        this.router = router;
    }

    public onClickTryAgain() {
        this.router.navigate([FfEndPoints.FINZY_FLEX]);
    }
}